import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/robot-list',
    name: 'robot-list',
    component: () => import('../views/robot/index.vue')
  },
  {
    path: '/robot-detail',
    name: 'robot-detail',
    component: () => import('../views/robot/detail.vue')
  },
  {
    path: '/digi-tech',
    name: 'digi-tech',
    // component: () => import('../views/digi-tech/index.vue')
    component: () => import('../views/digi-tech/old.vue')
  },
  {
    path: '/digi-survey',
    name: 'digi-survey',
    component: () => import('../views/digi-tech/digi-survey.vue')
  },
  {
    path: '/digi-design',
    name: 'digi-design',
    component: () => import('../views/digi-tech/digi-design.vue')
  },
  {
    path: '/digi-platform',
    name: 'digi-platform',
    component: () => import('../views/digi-tech/digi-platform.vue')
  },
  {
    path: '/digi-site',
    name: 'digi-site',
    component: () => import('../views/digi-tech/digi-site.vue')
  },
  {
    path: '/digi-weighbridge',
    name: 'digi-weighbridge',
    component: () => import('../views/digi-tech/digi-weighbridge.vue')
  },
  {
    path: '/digi-operation',
    name: 'digi-operation',
    component: () => import('../views/digi-tech/digi-operation.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/news')
  },
  {
    path: '/news-detail',
    name: 'news-detail',
    component: () => import('@/views/news/detail')
  },
  {
    path: '/medias',
    name: 'medias',
    component: () => import('@/views/medias/medias')
  },
  {
    path: '/media-detail',
    name: 'media-detail',
    component: () => import('@/views/medias/detail')
  },
  {
    path: '/build',
    name: 'build',
    component: () => import('@/views/build/build')
  },
  {
    path: '/build-detail',
    name: 'build-detail',
    component: () => import('@/views/build/detail')
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: () => import('@/views/introduce/introduce')
  },
  {
    path: '/achievement',
    name: 'achievement',
    component: () => import('@/views/achievement/achievement')
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: () => import('@/views/cooperation/cooperation')
  },
  {
    path: '/contact-index',
    name: 'contact-index',
    component: () => import('@/views/contact/index')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('@/views/contact/join')
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: () => import('@/views/contact/recruit')
  },
  {
    path: '/life',
    name: 'life',
    component: () => import('@/views/contact/life')
  },
  {
    path: '/building',
    name: 'building',
    component: () => import('@/views/contact/building')
  },
  {
    path: '/life-environment',
    name: 'life-environment',
    component: () => import('@/views/contact/life-environment')
  },
  {
    path: '/office-environment',
    name: 'office-environment',
    component: () => import('@/views/contact/office-environment')
  },
  {
    path: '/care',
    name: 'care',
    component: () => import('@/views/contact/care')
  },
  {
    path: '/train',
    name: 'train',
    component: () => import('@/views/contact/train')
  },
  {
    path: '/new-build',
    name: 'new-build',
    component: () => import('@/views/new-build/new-build')
  },
  {
    path: '/new-build-detail',
    name: 'new-build-detail',
    component: () => import('@/views/new-build/detail')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/download')
  },
  // {
  //   path: '/digi-tech',
  //   name: 'digi-tech',
  //   component: () => import('@/views/digi-tech')
  // }
]

const router = new VueRouter({
  routes
})

export default router
